import data from './attrs/data'
import methods from './attrs/methods'
import mounted from './attrs/mounted'
import watch from './attrs/watch'
import Autocomplete from "vuejs-auto-complete";

export default {
  name: 'Payables',
  components: {Autocomplete},
  data,
  methods,
  mounted,
  watch
}
